import React, {Component} from 'react'
import './BackOfficeUserScreen.css'
import ReactTable from 'react-table'
import moment from 'moment'

moment.locale('it')

export default class BackOfficeUserDetailLogsTable extends Component {
  constructor (props) {
    super(props)

    this.state = {
      columns: [
        {
          Header: 'ID',
          accessor: 'id',
          filterable: false,
          sortable: false,
          width: 80,
          Cell: (row) => {
            return (<div>{row && row.value && row.value}</div>)
          }
        },
        {
          Header: 'Utente',
          accessor: 'Operator',
          filterable: false,
          sortable: false,
          width: 150,
          Cell: (row) => {            
            return (<div>{ row && row.value && row.value.firstName + ' ' + row.value.lastName}</div>)
          }
        },
        {
          Header: 'Data',
          accessor: 'createdAt',
          filterable: false,
          sortable: false,
          width: 150,
          Cell: (row) => {
            return (<div>{ row && row.value && moment(row.value).format('L LT')}</div>)
          }
        },
        {
          Header: 'Codice',
          accessor: 'message',
          filterable: false,
          sortable: false,
          width: 150,
          Cell: (row) => {
            return (<div><strong>{ row && row.value && row.value}</strong></div>)
          }
        },
        {
          Header: 'Descrizione',
          accessor: 'description',
          filterable: false,
          sortable: false,
          Cell: (row) => {
            return (<div>{ row && row.value && row.value}</div>)
          }
        }
      ]

    }
  }

  render () {
    const {columns} = this.state
    return (<div>
      <ReactTable
        loading={this.props.loading}
        noDataText={'Nessun Log Presente'}
        className="-highlight"
        data={this.props.logs ? this.props.logs : []}
        style={{maxHeight: '500px'}}
        defaultPageSize={100}
        nextText="Avanti"
        previousText="Indietro"
        loadingText="Caricamento in corso..."
        rowsText="elementi"
        ofText="di"
        pageText="Pagina"
        columns={columns} />
    </div>)
  }
}



// WEBPACK FOOTER //
// ./src/screens/BackOfficeUserDetailLogsTable.js